import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { Tab, Tabs } from 'react-bootstrap';
import Constants from '../../config/constants';
import { COLUMN_STYLE, getColumnStyle } from '../../components/datatable/util';
import Layout from '../../components/layout/Layout';
import Card from '../../components/card/Card';
import RelationDataTable from '../../components/datatable/RelationDataTable';
import { Link } from 'react-router-dom';

import { FORMATTER_STYLE, getFormatter } from '../../utils/formatter';
import { InfoCard } from '../../components/card/InfoCard';
import FloorEditModal from '../../modal/floor/FloorEditModal';
import Alert from '../../modal/alert/Alert';

import {
  defaultRejectHandler,
  getErrorValue,
  stringifyErrorMessage,
} from '../../utils/utility';

import {
  getFloor,
  deleteFloor,
  clearErrorFloor,
} from '../../redux/floor/floor_actions';

import {
  searchZoneByText,
  listZone,
  addZoneToFloor,
  removeZoneFromFloor,
} from '../../redux/zone/zone_actions';

class FloorDetailPage extends React.Component {
  constructor(props) {
    super(props);

    this.search = {
      pageSize: Constants.DATA_TABLE_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    this.state = {
      categoryOption: 'all',
      isShowCreateModal: false,
      isShowEditModal: false,
      isShowDeleteModal: false,
      isDuplicateModal: false,
    };
  }

  renderActionMenu() {
    const { t } = this.props;
    return [
      <li>
        <a
          href="#"
          data-toggle="modal"
          data-target="#edit-floor"
          onClick={() => this.setState({ isShowEditModal: true })}
        >
          <i className="fas fa-edit" />
          <span className="menu-text">{t('edit floor')}</span>
        </a>
      </li>,
      <li>
        <a
          href="#"
          data-toggle="modal"
          data-target="#delete-floor"
          onClick={() => this.setState({ isShowDeleteModal: true })}
        >
          <i className="fas fa-trash" />
          <span className="menu-text">{t('delete floor')}</span>
        </a>
      </li>,
    ];
  }

  componentDidMount() {
    this.props.getFloor(this.props.match.params.floorId);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isEditing && nextProps.isEditing !== this.props.isEditing && !nextProps.floorErrorMessage) {
      this.setState({ isShowEditModal: false });
    }

    if (this.props.isDeleting && this.props.isDeleting !== nextProps.isDeleting && !nextProps.floorErrorMessage) {
      this.props.history.push(`/projects/${this.props.floorDetail.project_id}`);
    }
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;

    this.props.listZone(
      this.search.pageSize,
      this.search.page,
      this.search.sorted,
      this.search.filtered,
      {
        all: null,
        public: true,
        private: false,
      }[category],
    );

    this.setState({ categoryOption: category });
  }

  dismissDeleteModal() {
    this.props.clearError();
    this.setState({ isShowDeleteModal: false });
  }

  dismissEditModal() {
    this.props.clearError();
    this.setState({ isShowEditModal: false });
  }

  renderFloor(floor) {
    const { t, isDeleting, floorErrorMessage } = this.props;
    const { isShowEditModal, isShowDeleteModal } = this.state;

    const fields = [
      {
        id: 'project-name',
        label: t('project name'),
        value: floor.building_name || t('unassigned'),
      },
      {
        id: 'floor-area',
        label: t('area'),
        value: `${floor.area === null ? '-' : getFormatter(FORMATTER_STYLE.floatFractionDigit2)(floor.area)} ${t('sq m')}`,
      },
      {
        id: 'floor-description',
        label: t('description'),
        value: floor.description || '-',
      },
    ];

    return (
      <React.Fragment>
        <h1>{floor.name}</h1>
        <FloorEditModal
          floor={floor}
          show={isShowEditModal}
          onHide={() => this.dismissEditModal()}
        />
        <Alert
          show={isShowDeleteModal}
          onHide={() => !isDeleting && this.dismissDeleteModal()}
          title={t('delete floor')}
          body={`${t('do you want to delete')} ${floor ? floor.name : ''}?`}
          errorMessage={getErrorValue(floorErrorMessage, 'detail')}
          primaryButtonTitle={isDeleting ? t('deleting') : t('delete')}
          primaryButtonStyle={'danger'}
          primaryButtonEnabled={!isDeleting}
          onPrimaryButtonClick={() => this.props.deleteFloor(floor)}
        />
        <InfoCard fields={fields} />
      </React.Fragment>
    );
  }

  renderZone(zones) {
    const {
      filteredCount,
      isLoading,
      isAddingToFloor,
      isRemovingFromFloor,
      addZoneToFloor,
      removeZoneFromFloor,
      zoneErrorMessage,
      floorDetail,
      t,
    } = this.props;

    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const coefficientColumn = getColumnStyle(COLUMN_STYLE.coefficient);

    const columns = [
      {
        id: 'floor_zone_name',
        Header: () => <b>{t('name')}</b>,
        accessor: item => ({ name: item.name, id: item.id }),
        Cell: row => <Link to={`/zones/${row.value.id}`}>{row.value.name}</Link>,
        ...textColumn,
        entity: {
          list: (text, page) => searchZoneByText(text, floorDetail.building_id, page, null)
            .then(response => response.data.map(({name, id}) => ({label: name, value: String(id)}))),
        },
      },
      {
        Header: () => <b>{`${t('area')} (${t('sq m')})`}</b>,
        accessor: 'area',
        ...coefficientColumn,
      },
      {
        Header: () => <b>{t('air conditioning system')}</b>,
        Cell: row => row.value ? t('available') : t('not available'),
        accessor: 'has_ac',
        ...textColumn,
      },
    ];

    const relationship = {
      create: ({ entityId }) => addZoneToFloor(entityId),
      delete: id => removeZoneFromFloor(id),
      isCreating: isAddingToFloor,
      isDeleting: isRemovingFromFloor,
    };

    return (
      <Card padding={false}>
        <Tabs id="floor-zone-tabs">
          <Tab title={t('zones')} eventKey={1}>
            <RelationDataTable
              columns={columns}
              data={zones}
              errorMessage={stringifyErrorMessage(zoneErrorMessage)}
              relationship={relationship}
              onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedInstance: item.original })}
              filteredCount={filteredCount}
              isLoading={isLoading}
              onFetchData={state => this.updateSortFilter(this.search.filtered, state, this.state.categoryOption)}
            />
          </Tab>
        </Tabs>
      </Card>
    );
  }

  getBreadcrumb(floor) {
    if (floor.is_project_mixed_use) {
      return [
        {
          name: floor.building_name,
          path: `/buildings/${floor.building_id}`,
        },
        {
          name: floor.name,
          path: `/floors/${floor.id}`,
        },
      ];
    } else {
      return [
        {
          name: floor.building_name,
          path: `/projects/${floor.project_id}`,
        },
        {
          name: floor.name,
          path: `/floors/${floor.id}`,
        },
      ];
    }
  }

  render() {
    const { floorDetail: floor, zones } = this.props;

    return (
      <Layout
        history={this.props.history}
        breadcrumbItems={floor ? this.getBreadcrumb(floor) : []}
        renderActionMenu={() => this.renderActionMenu()}
      >
        {floor && this.renderFloor(floor)}
        {floor && this.renderZone(zones)}
      </Layout>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  floorDetail: state.floor.objects[ownProps.match.params.floorId],
  isEditing: state.floor.isEditing,
  isDeleting: state.floor.isDeleting,
  zones: state.zone.orderedIds.map(id => state.zone.objects[id]),
  filteredCount: state.zone.filteredCount,
  isLoading: state.zone.isLoading,
  isAddingToFloor: state.zone.isAddingToFloor,
  isRemovingFromFloor: state.zone.isRemovingFromFloor,
  floorErrorMessage: state.floor.errorMessage,
  zoneErrorMessage: state.zone.errorMessage,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  getFloor: id => defaultRejectHandler(dispatch(getFloor(id))),
  deleteFloor: ({ id }) => defaultRejectHandler(dispatch(deleteFloor(id))),
  listZone: (pageSize, page, sorted, filtered, isPublic) =>
    defaultRejectHandler(dispatch(listZone(pageSize, page, sorted, filtered, isPublic, null, ownProps.match.params.floorId))),
  addZoneToFloor: id => defaultRejectHandler(dispatch(addZoneToFloor(id, ownProps.match.params.floorId))),
  removeZoneFromFloor: id => defaultRejectHandler(dispatch(removeZoneFromFloor(id))),
  clearError: () => dispatch(clearErrorFloor()),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(FloorDetailPage),
);



// WEBPACK FOOTER //
// ./src/pages/floor/FloorDetailPage.js